import { useFingerprint as useFingerprintContext } from './FingerprintContext';

export const useFingerprint = () => useFingerprintContext();
